import CryptoJS from "crypto-js";

// Get values securely from environment
const clientId = String(process.env.REACT_APP_JWT_USERNAME);
// const clientId = "BZNsxkblZkPjmqQsBBUiZpqc2c6BLWpW"
const clientIdYR = "YRH5q6VM0kgJl9dTQ4JVPPkwAxmzjjuOMIwdEBfOxY6HowH3"
if (!clientId) {
 console.error("REACT_APP_CLIENT_ID is missing in your .env file");
}
const key = CryptoJS.enc.Utf8.parse(clientId.slice(-32));
const iv = CryptoJS.enc.Utf8.parse(clientId.slice(-16));

const key_yr = CryptoJS.enc.Utf8.parse(clientIdYR.slice(-32));
const iv_yr = CryptoJS.enc.Utf8.parse(clientIdYR.slice(-16));

export function encryptAES(plainText) {
 const encrypted = CryptoJS.AES.encrypt(
   CryptoJS.enc.Utf8.parse(plainText),
   key,
   {
     iv: iv,
     mode: CryptoJS.mode.CBC,
     padding: CryptoJS.pad.Pkcs7,
   }
 );
 return encrypted.toString(); // Base64 encoded
}
export function decryptAES(encryptedText) {
  console.log("Retrieved Client ID Successfully:" ,clientId)
  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
   iv: iv,
   mode: CryptoJS.mode.CBC,
   padding: CryptoJS.pad.Pkcs7,
 });

 return decrypted.toString(CryptoJS.enc.Utf8);
}

export function encryptAESYR(plainText) {
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(plainText),
    key_yr,
    {
      iv: iv_yr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString(); // Base64 encoded
}

export function decryptAESYR(encryptedText) {
   const decrypted = CryptoJS.AES.decrypt(encryptedText, key_yr, {
    iv: iv_yr,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
 
  return decrypted.toString(CryptoJS.enc.Utf8);
 }